import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import moment from "moment";

import Status from "components/global/Status";
import EditTSvg from "assets/svgs/EditTSvg";
import TealPagination from "components/global/TealPagination";
import PageLimit from "components/global/PageLimit";
import ExportButton from "components/global/exportbutton/ExportButton";
import Axios from "config/api";
import EditDueDateModal from "./EditDueDateModal";
import { updateInstallmentDoc } from "redux/slices/installmentSlice";


const InventoryInstallmentTable = ({
  currentInstallmentPage,
  setCurrentInstallmentPage,
  limitInstallment,
  setLimitInstallment,
}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { id } = useParams();

  const [storeData, setStoreData] = useState([]);
  const [editingInstallment, setEditingInstallment] = useState(null);

  const { docs, pages, docsCount } = useSelector((state) => state.installment);
  const { docDetails } = useSelector((state) => state.inventory);
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = Boolean(user?.isSuperAdmin);

  const start = (currentInstallmentPage - 1) * limitInstallment + 1;
  const end = start + docs.length - 1;
function formatLabel(text = "") {
  return text
    .replace(/_/g, " ")       
    .split(" ")               
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");           
}




useEffect(() => {
  async function fetchInstallments() {
    try {
      const res = await Axios.get(
        `/sale/get-all-installments?inventory=${id}&pageSize=${docsCount}&page=1&excludeCancelled=true`
      );
      
      console.log("res", res);
      
      const fetchedDocs = res.data.data.docs || [];
      fetchedDocs.sort((a, b) => {
        const isInitialA = a.type === "down_payment" || a.type === "full_payment";
        const isInitialB = b.type === "down_payment" || b.type === "full_payment";
        if (isInitialA && !isInitialB) return -1;
        if (!isInitialA && isInitialB) return 1;
        return (a.seq || 0) - (b.seq || 0);
      });
      setStoreData(fetchedDocs);
      
    } catch (error) {
      console.error("Error fetching installments", error);
    }
  }

  fetchInstallments();
}, [id, docsCount,]);

const exportTableData = storeData?.map((item, index) => ({
  No: index + 1,
  "Inventory": item?.inventory?.fullNumber || "-",
  "Installment Type": formatLabel(item?.type) || "-",
  "Payment Type": formatLabel(item?.sale?.paymentType) || "-",
  "Total Payment": item?.amount || 0,
  "Paid Payment": item?.paidAmount || 0,
  "Remaining Amount": (item?.amount || 0) - (item?.paidAmount || 0),
  "Due Date": item?.dueDate ? moment(item?.dueDate).format("DD-MM-YYYY") : "-",
  "Created By": item?.createdBy?.username || "-",
})) || [];

const roundedTotalPayment = Math.round(
  storeData.reduce((total, item) => total + Number(item?.amount || 0), 0)
);
const roundedPaidPayment = Math.round(
  storeData.reduce((total, item) => total + Number(item?.paidAmount || 0), 0)
);
const installmentReport = {
  inventoryValue:
    storeData?.[0]?.sale?.sellingPrice ??
    storeData?.[0]?.inventory?.currentSale?.sellingPrice ??
    docDetails?.currentSale?.sellingPrice ??
    0,
  summary: {
    totalPayment: roundedTotalPayment,
    paidPayment: roundedPaidPayment,
    remainingAmount: roundedTotalPayment - roundedPaidPayment,
  },
};

  const sortedDocs = [...docs].sort((a, b) => {
    const isInitialA = a.type === "down_payment" || a.type === "full_payment";
    const isInitialB = b.type === "down_payment" || b.type === "full_payment";
    if (isInitialA && !isInitialB) return -1;
    if (!isInitialA && isInitialB) return 1;
    return (a.seq || 0) - (b.seq || 0);
  });

  return (
      <>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between w-full px-3 pt-3">
        <p className="form-title">Installments Plan</p>
       


<ExportButton
  title="Inventory Installments"
  tableData={exportTableData}
  columns={[
    "No",
    "Inventory",
    "Installment Type",
    "Payment Type",
    "Total Payment",
    "Paid Payment",
    "Remaining Amount",
    "Due Date",
    "Created By",
  ]}
  fileName="Inventory Installments"
  bgcolor="bg-primary"
  textColor="text-white"
  docDetails={docDetails}
  installmentReport={installmentReport}
/>


      </div>

      {/* Table */}
      <div className="overflow-x-auto maintable">
        <table className="w-full text-sm md:text-[15px] bg-white">
          <thead className="text-left border-b  text-gray-600">
            <tr>
              {/* <th className="px-6 py-4 whitespace-nowrap">
                <label className="relative inline-block w-[16px] h-[16px]">
                  <input
                    type="checkbox"
                    checked={
                      selectedRows.length === tableData.length &&
                      tableData.length > 0
                    }
                    onChange={handleSelectAll}
                    className="peer appearance-none w-full h-full border border-gray3 rounded-[5px] checked:border-gray-800 cursor-pointer"
                  />
                  <span className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-0 peer-checked:opacity-100">
                    <CheckAllSVG className="w-4 h-4 text-primary" />
                  </span>
                </label>
              </th> */}
              <th className="px-3 py-4">
              No</th>
             
              <th className="px-3 py-4">
        
                     Inventory
                 
     
             </th> 
              <th className="px-3 py-4">
        
                     Installment Type
                 
     
             </th> 
              <th className="px-3 py-4">
                          Payment  Type
          
             </th>
          



               <th className="px-3 py-4 whitespace-nowrap">
                  Total Payment
                </th>

                <th className="px-3 py-4 whitespace-nowrap">
                    Paid  Payment
                </th>

                  <th className="px-3 py-4 whitespace-nowrap">
                    Remaining Amount
                
                </th>
              <th className="px-3 py-4">
           
                       Due Date
        
              </th>
              <th className="px-3 py-4">
          
              Created By
     
       
              </th>
              <th className="px-3 py-4">
          
              Status
     
       
              </th>

                   <th className="px-3 py-4 whitespace-nowrap">Action</th>

            </tr>
          </thead>

          <tbody>
            {sortedDocs.map((row, index) => (

              <tr
                onClick={() => {
                  if(row.status !=='paid'){
                navigate(`/app/installments/${row?._id}`)
                  }
                 }}

                key={row?._id}
                className={`border-b hover:bg-gray-50 transition `}
              >

                <td className="px-3 py-4 font-medium text-gray-800">
                  {row?.seq ?? (index + 1)}
                </td>
                <td className="px-3 py-4 capitalize">
                    {row?.inventory?.fullNumber}
                </td>
                <td className="px-3 py-4 capitalize">
                    {row?.type}
                </td>
                <td className="px-3 py-4">
       {formatLabel(row?.sale?.paymentType)}
                </td>
                <td className="px-3 py-4">
        {row?.amount}
                </td>
                    <td className="px-3 py-4">
        {row?.paidAmount}
                </td>
                    <td className="px-3 py-4">
        {row?.amount-row?.paidAmount}
                </td>
        <td className="px-3 py-4">
          {row?.dueDate ? moment(row?.dueDate).format("DD-MM-YYYY") : "-"}
                </td>
        <td className="px-3 py-4">
{row?.createdBy?.username ??""}                </td>
                <td className="px-3 py-4">
                  <Status status={row?.status} />
                </td>
                <td className="px-3 py-4">
                  <div className="flex flex-row gap-2 items-center">
                    {row?.status !== "paid" && row?.status !== "cancelled" && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/app/installments/${row?._id}`);
                        }}
                        className="w-fit px-3 py-1.5 rounded-lg bg-primary text-white text-xs sm:text-sm font-medium hover:bg-primary/90 transition shadow-sm"
                      >
                        Pay
                      </button>
                    )}

                    {isSuperAdmin && row?.status !== "cancelled" && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingInstallment(row);
                        }}
                        title="Edit Due Date"
                        className="p-1.5 rounded-lg border bg-primary text-primary hover:bg-[#54A6FF] hover:text-white transition flex items-center justify-center shadow-sm"
                      >
                        <EditTSvg className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer (Pagination + Limit) */}
      <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center w-full px-3  flex-wrap-none">
               <TealPagination

           totalPages={pages}
              currentPage={currentInstallmentPage}
             setCurrentPage={setCurrentInstallmentPage}
      />
                                      {/* Limit Dropdown */}

                            <div className=' flex items-center justify-between sm:justify-start  gap-2'>
  <p className="text-sm sm:text-base text-[#A8A8A8]">

  Showing {docsCount === 0 ? 0 : start} to {docsCount === 0 ? 0 : end} of {docsCount} entries
</p>

                                   <div className="w-[140px] h-[40px] ">
                               <PageLimit totalpages={docsCount || 10} limit={limitInstallment} setLimit={setLimitInstallment} />
                                  </div>
                            </div>




                                    </div>

      {editingInstallment && (
        <EditDueDateModal
          installment={editingInstallment}
          onClose={() => setEditingInstallment(null)}
          onSuccess={(updatedDoc) => {
            dispatch(updateInstallmentDoc(updatedDoc));
            setStoreData((prev) =>
              prev.map((item) => (item._id === updatedDoc._id ? { ...item, ...updatedDoc } : item))
            );
            queryClient.invalidateQueries("fetch-all-installments");
            queryClient.invalidateQueries("single-inventory");
            setEditingInstallment(null);
          }}
        />
      )}

</>


  );
};

export default InventoryInstallmentTable;
